export enum contactButtons  {
    commit = 'commit',
    mute ='mute',
    mask = 'mask',
    hold = 'hold',
    transfer= 'transfer',
    keypad = 'keypad',
    record= 'record',
    consult= 'consult',
    hungup = 'hungup',
    outBoundCall= 'outBoundCall',
    commitment='commitment',
    cobrowsing='cobrowsing',
    location='location',
  
   }